import React from "react";
import { useState } from "react";
import { axios_instance } from "../api/axios_instance";
import {
  extractNumbersFromString,
  extractStringWithoutNumbers,
} from "../utils/helperFunctions";

const FormTriggers = ({
  triggerName,
  disabled,
  width = "30%",
  showYesButton = true,
  showNoButton = true,
  triggerValues,
  caseDetails,
  errorClass,
  handleTriggerChange,
}) => {
  const [triggerValuesState, setTriggerValuesState] = useState(
    triggerValues[triggerName]
  );

  const triggerFieldName = extractStringWithoutNumbers(triggerName);
  let count = extractNumbersFromString(triggerName);

  const handleChange = async (value) => {
    if (handleTriggerChange)
      handleTriggerChange(count, value, triggerFieldName);
    setTriggerValuesState(value);
    try {
      await axios_instance({
        url: "/dts/formTriggerActions",
        method: "POST",
        data: {
          value,
          name: `${triggerName}_C`,
          action: "checker",
          disbursement_id: caseDetails.id,
          fcmid: caseDetails.finance_lead_id,
          fcm_bank_id: caseDetails.fcm_bank_id,
          type: "C",
          step_details: caseDetails.step_details,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <td width={width}>
      {showYesButton && (
        <span>
          <input
            type="radio"
            disabled={disabled}
            name={`${triggerName}`}
            id={`${triggerName}_C-yes1`}
            className="trigger"
            checked={triggerValuesState === "1"}
            onChange={() => handleChange("1")}
          />
          <label
            htmlFor={`${triggerName}_C-yes1`}
            className="detail-form-label"
          >
            <span className={`dt-yes ${errorClass}`}></span>
          </label>
        </span>
      )}

      {showNoButton && (
        <span className={`span_${triggerName}_C`}>
          <input
            type="radio"
            disabled={disabled}
            name={`${triggerName}`}
            id={`${triggerName}_C-no1`}
            className="trigger"
            checked={triggerValuesState === "0"}
            onChange={() => handleChange("0")}
          />
          <label htmlFor={`${triggerName}_C-no1`}>
            <span className={`dt-no ${errorClass}`}></span>
          </label>
        </span>
      )}
    </td>
  );
};

export default FormTriggers;
